import Controller from 'controllers/controller';
import CarouselController from 'controllers/carousel';
import Binder from 'tools/binder';

class EventsController extends Controller {
    constructor(app) {
        super(app);
        
        this.root = document.querySelector('.page[data-template="events"]');
        this.binder = new Binder(this);

        this.elements = { };
        this.carouselMain = null;
        this.carouselNavigation = null;

        this.app.loaderController.on('events-loaded', () => {
            this.cacheElements();
            this.initGallery();
            this.attachEvents();
        })
    }

    cacheElements() {
        this.elements.carouselMain = document.querySelector('#gallery .carousel-main .carousel');
        this.elements.carouselNavigation = document.querySelector('#gallery .carousel-navigation .carousel');
        this.elements.viewGalleryButtons = Array.from(this.root.querySelectorAll('.view-gallery-button'));
    }
    
    attachEvents() {
        if (this.elements.viewGalleryButtons.length > 0) {
            this.elements.viewGalleryButtons.forEach(button => {
                button.addEventListener('click', this.binder.bind('onViewGalleryClick'));
            });
        }
    }

    onViewGalleryClick(event) {
        event.preventDefault();

        this.app.modalsController.openModal('gallery');

        this.carouselMain.carousel.resize();
        this.carouselNavigation.carousel.resize();
    }

    initGallery() {
        if (this.elements.viewGalleryButtons.length > 0) {
            this.carouselMain = this.app.make(CarouselController, this.elements.carouselMain, {
                wrapAround: true,
                draggable: '>1',
                pageDots: false,
                setGallerySize: false,
            });
        }

        if (this.elements.viewGalleryButtons.length > 0) {
            this.carouselNavigation = this.app.make(CarouselController, this.elements.carouselNavigation, {
//            draggable: '>1',
                setGallerySize: false,
                prevNextButtons: false,
                pageDots: false,
                contain: true,
//            groupCells: 5,
                asNavFor: this.elements.carouselMain
            });
        }
    }
}

export default EventsController;